// Generated from AioExpressionParser.g4 by ANTLR 4.13.1
// noinspection ES6UnusedImports,JSUnusedGlobalSymbols,JSUnusedLocalSymbols
import { ATN, ATNDeserializer, DFA, FailedPredicateException, RecognitionException, NoViableAltException, Parser, ParserATNSimulator, ParserRuleContext, PredictionContextCache, Token, } from 'antlr4';
export default class AioExpressionParser extends Parser {
    static DYNAMIC_START = 1;
    static TEXT = 2;
    static DYNAMIC_END = 3;
    static FORMAT_NUMBER_DIGITS = 4;
    static DISPLAY_IF = 5;
    static SUBSTRING = 6;
    static ADD = 7;
    static SUB = 8;
    static MUL = 9;
    static DIV = 10;
    static MOD = 11;
    static LT = 12;
    static LTE = 13;
    static GT = 14;
    static GTE = 15;
    static OR = 16;
    static AND = 17;
    static NOT = 18;
    static EQUALS = 19;
    static NOT_EQUALS = 20;
    static E_C_NAME = 21;
    static E_C_T_NAME = 22;
    static E_C_P_NAME = 23;
    static EM_SPECIFIER = 24;
    static EM_C_NAME = 25;
    static EM_C_T_NAME = 26;
    static EM_C_P_NAME = 27;
    static EMO_SPECIFIER = 28;
    static EMO_C_NAME = 29;
    static EMO_C_T_NAME = 30;
    static EMO_C_P_NAME = 31;
    static NUMBER = 32;
    static WS = 33;
    static COMMA = 34;
    static ASSIGN = 35;
    static SEMICOLON = 36;
    static SINGLE_QUOTE = 37;
    static DOUBLE_QUOTE = 38;
    static SQUARE_BRACKET_OPEN = 39;
    static SQUARE_BRACKET_CLOSE = 40;
    static PARENTHESIS_OPEN = 41;
    static PARENTHESIS_CLOSE = 42;
    static STRING = 43;
    static EOF = Token.EOF;
    static RULE_input = 0;
    static RULE_element = 1;
    static RULE_dynamicExpr = 2;
    static RULE_statement = 3;
    static RULE_expr = 4;
    static RULE_id = 5;
    static RULE_eventCompetitorId = 6;
    static RULE_eventMarketSpecifierId = 7;
    static RULE_eventMarketCompetitorId = 8;
    static RULE_eventMarketOutcomeSpecifierId = 9;
    static RULE_eventMarketOutcomeCompetitorId = 10;
    static RULE_stringArg = 11;
    static RULE_numberArg = 12;
    static RULE_funct = 13;
    static literalNames = [
        null,
        "'{{'",
        null,
        "'}}'",
        "'FORMAT_NUMBER_DIGITS'",
        "'DISPLAY_IF'",
        "'SUBSTRING'",
        "'+'",
        "'-'",
        "'*'",
        "'/'",
        "'%'",
        "'<'",
        "'<='",
        "'>'",
        "'>='",
        "'||'",
        "'&&'",
        "'!'",
        "'=='",
        "'!='",
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        "','",
        "'='",
        "';'",
        "'''",
        "'\"'",
        "'['",
        "']'",
        "'('",
        "')'",
    ];
    static symbolicNames = [
        null,
        'DYNAMIC_START',
        'TEXT',
        'DYNAMIC_END',
        'FORMAT_NUMBER_DIGITS',
        'DISPLAY_IF',
        'SUBSTRING',
        'ADD',
        'SUB',
        'MUL',
        'DIV',
        'MOD',
        'LT',
        'LTE',
        'GT',
        'GTE',
        'OR',
        'AND',
        'NOT',
        'EQUALS',
        'NOT_EQUALS',
        'E_C_NAME',
        'E_C_T_NAME',
        'E_C_P_NAME',
        'EM_SPECIFIER',
        'EM_C_NAME',
        'EM_C_T_NAME',
        'EM_C_P_NAME',
        'EMO_SPECIFIER',
        'EMO_C_NAME',
        'EMO_C_T_NAME',
        'EMO_C_P_NAME',
        'NUMBER',
        'WS',
        'COMMA',
        'ASSIGN',
        'SEMICOLON',
        'SINGLE_QUOTE',
        'DOUBLE_QUOTE',
        'SQUARE_BRACKET_OPEN',
        'SQUARE_BRACKET_CLOSE',
        'PARENTHESIS_OPEN',
        'PARENTHESIS_CLOSE',
        'STRING',
    ];
    // tslint:disable:no-trailing-whitespace
    static ruleNames = [
        'input',
        'element',
        'dynamicExpr',
        'statement',
        'expr',
        'id',
        'eventCompetitorId',
        'eventMarketSpecifierId',
        'eventMarketCompetitorId',
        'eventMarketOutcomeSpecifierId',
        'eventMarketOutcomeCompetitorId',
        'stringArg',
        'numberArg',
        'funct',
    ];
    get grammarFileName() {
        return 'AioExpressionParser.g4';
    }
    get literalNames() {
        return AioExpressionParser.literalNames;
    }
    get symbolicNames() {
        return AioExpressionParser.symbolicNames;
    }
    get ruleNames() {
        return AioExpressionParser.ruleNames;
    }
    get serializedATN() {
        return AioExpressionParser._serializedATN;
    }
    createFailedPredicateException(predicate, message) {
        return new FailedPredicateException(this, predicate, message);
    }
    constructor(input) {
        super(input);
        this._interp = new ParserATNSimulator(this, AioExpressionParser._ATN, AioExpressionParser.DecisionsToDFA, new PredictionContextCache());
    }
    // @RuleVersion(0)
    input() {
        let localctx = new InputContext(this, this._ctx, this.state);
        this.enterRule(localctx, 0, AioExpressionParser.RULE_input);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 31;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 1 || _la === 2) {
                    {
                        {
                            this.state = 28;
                            this.element();
                        }
                    }
                    this.state = 33;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
                this.state = 34;
                this.match(AioExpressionParser.EOF);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    element() {
        let localctx = new ElementContext(this, this._ctx, this.state);
        this.enterRule(localctx, 2, AioExpressionParser.RULE_element);
        try {
            this.state = 38;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 36;
                        this.dynamicExpr();
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 37;
                        this.match(AioExpressionParser.TEXT);
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    dynamicExpr() {
        let localctx = new DynamicExprContext(this, this._ctx, this.state);
        this.enterRule(localctx, 4, AioExpressionParser.RULE_dynamicExpr);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 40;
                this.match(AioExpressionParser.DYNAMIC_START);
                this.state = 44;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (((_la & ~0x1f) === 0 && ((1 << _la) & 4293132400) !== 0) ||
                    _la === 32 ||
                    _la === 41) {
                    {
                        {
                            this.state = 41;
                            this.statement();
                        }
                    }
                    this.state = 46;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
                this.state = 47;
                this.match(AioExpressionParser.DYNAMIC_END);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    statement() {
        let localctx = new StatementContext(this, this._ctx, this.state);
        this.enterRule(localctx, 6, AioExpressionParser.RULE_statement);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 49;
                this.expr(0);
                this.state = 51;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 36) {
                    {
                        this.state = 50;
                        this.match(AioExpressionParser.SEMICOLON);
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    expr(_p) {
        if (_p === undefined) {
            _p = 0;
        }
        let _parentctx = this._ctx;
        let _parentState = this.state;
        let localctx = new ExprContext(this, this._ctx, _parentState);
        let _prevctx = localctx;
        let _startState = 8;
        this.enterRecursionRule(localctx, 8, AioExpressionParser.RULE_expr, _p);
        let _la;
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 63;
                this._errHandler.sync(this);
                switch (this._input.LA(1)) {
                    case 32:
                        {
                            localctx = new NumberContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 54;
                            this.match(AioExpressionParser.NUMBER);
                        }
                        break;
                    case 21:
                    case 22:
                    case 23:
                    case 24:
                    case 25:
                    case 26:
                    case 27:
                    case 28:
                    case 29:
                    case 30:
                    case 31:
                        {
                            localctx = new ExtractIdContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 55;
                            this.id();
                        }
                        break;
                    case 41:
                        {
                            localctx = new ParensContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 56;
                            this.match(AioExpressionParser.PARENTHESIS_OPEN);
                            this.state = 57;
                            this.expr(0);
                            this.state = 58;
                            this.match(AioExpressionParser.PARENTHESIS_CLOSE);
                        }
                        break;
                    case 18:
                        {
                            localctx = new NotContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 60;
                            this.match(AioExpressionParser.NOT);
                            this.state = 61;
                            this.expr(2);
                        }
                        break;
                    case 4:
                    case 5:
                    case 6:
                        {
                            localctx = new FuncContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 62;
                            this.funct();
                        }
                        break;
                    default:
                        throw new NoViableAltException(this);
                }
                this._ctx.stop = this._input.LT(-1);
                this.state = 82;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 6, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        if (this._parseListeners != null) {
                            this.triggerExitRuleEvent();
                        }
                        _prevctx = localctx;
                        {
                            this.state = 80;
                            this._errHandler.sync(this);
                            switch (this._interp.adaptivePredict(this._input, 5, this._ctx)) {
                                case 1:
                                    {
                                        localctx = new MulDivContext(this, new ExprContext(this, _parentctx, _parentState));
                                        this.pushNewRecursionContext(localctx, _startState, AioExpressionParser.RULE_expr);
                                        this.state = 65;
                                        if (!this.precpred(this._ctx, 7)) {
                                            throw this.createFailedPredicateException('this.precpred(this._ctx, 7)');
                                        }
                                        this.state = 66;
                                        localctx._op = this._input.LT(1);
                                        _la = this._input.LA(1);
                                        if (!(_la === 9 || _la === 10)) {
                                            localctx._op = this._errHandler.recoverInline(this);
                                        }
                                        else {
                                            this._errHandler.reportMatch(this);
                                            this.consume();
                                        }
                                        this.state = 67;
                                        this.expr(8);
                                    }
                                    break;
                                case 2:
                                    {
                                        localctx = new AddSubContext(this, new ExprContext(this, _parentctx, _parentState));
                                        this.pushNewRecursionContext(localctx, _startState, AioExpressionParser.RULE_expr);
                                        this.state = 68;
                                        if (!this.precpred(this._ctx, 6)) {
                                            throw this.createFailedPredicateException('this.precpred(this._ctx, 6)');
                                        }
                                        this.state = 69;
                                        localctx._op = this._input.LT(1);
                                        _la = this._input.LA(1);
                                        if (!(_la === 7 || _la === 8)) {
                                            localctx._op = this._errHandler.recoverInline(this);
                                        }
                                        else {
                                            this._errHandler.reportMatch(this);
                                            this.consume();
                                        }
                                        this.state = 70;
                                        this.expr(7);
                                    }
                                    break;
                                case 3:
                                    {
                                        localctx = new ModuloContext(this, new ExprContext(this, _parentctx, _parentState));
                                        this.pushNewRecursionContext(localctx, _startState, AioExpressionParser.RULE_expr);
                                        this.state = 71;
                                        if (!this.precpred(this._ctx, 5)) {
                                            throw this.createFailedPredicateException('this.precpred(this._ctx, 5)');
                                        }
                                        this.state = 72;
                                        this.match(AioExpressionParser.MOD);
                                        this.state = 73;
                                        this.expr(6);
                                    }
                                    break;
                                case 4:
                                    {
                                        localctx = new RelationalContext(this, new ExprContext(this, _parentctx, _parentState));
                                        this.pushNewRecursionContext(localctx, _startState, AioExpressionParser.RULE_expr);
                                        this.state = 74;
                                        if (!this.precpred(this._ctx, 4)) {
                                            throw this.createFailedPredicateException('this.precpred(this._ctx, 4)');
                                        }
                                        this.state = 75;
                                        localctx._op = this._input.LT(1);
                                        _la = this._input.LA(1);
                                        if (!((_la & ~0x1f) === 0 && ((1 << _la) & 1634304) !== 0)) {
                                            localctx._op = this._errHandler.recoverInline(this);
                                        }
                                        else {
                                            this._errHandler.reportMatch(this);
                                            this.consume();
                                        }
                                        this.state = 76;
                                        this.expr(5);
                                    }
                                    break;
                                case 5:
                                    {
                                        localctx = new LogicalContext(this, new ExprContext(this, _parentctx, _parentState));
                                        this.pushNewRecursionContext(localctx, _startState, AioExpressionParser.RULE_expr);
                                        this.state = 77;
                                        if (!this.precpred(this._ctx, 3)) {
                                            throw this.createFailedPredicateException('this.precpred(this._ctx, 3)');
                                        }
                                        this.state = 78;
                                        localctx._op = this._input.LT(1);
                                        _la = this._input.LA(1);
                                        if (!(_la === 16 || _la === 17)) {
                                            localctx._op = this._errHandler.recoverInline(this);
                                        }
                                        else {
                                            this._errHandler.reportMatch(this);
                                            this.consume();
                                        }
                                        this.state = 79;
                                        this.expr(4);
                                    }
                                    break;
                            }
                        }
                    }
                    this.state = 84;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 6, this._ctx);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.unrollRecursionContexts(_parentctx);
        }
        return localctx;
    }
    // @RuleVersion(0)
    id() {
        let localctx = new IdContext(this, this._ctx, this.state);
        this.enterRule(localctx, 10, AioExpressionParser.RULE_id);
        try {
            this.state = 94;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 21:
                case 22:
                case 23:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 85;
                        this.eventCompetitorId();
                    }
                    break;
                case 24:
                case 25:
                case 26:
                case 27:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 88;
                        this._errHandler.sync(this);
                        switch (this._input.LA(1)) {
                            case 24:
                                {
                                    this.state = 86;
                                    this.eventMarketSpecifierId();
                                }
                                break;
                            case 25:
                            case 26:
                            case 27:
                                {
                                    this.state = 87;
                                    this.eventMarketCompetitorId();
                                }
                                break;
                            default:
                                throw new NoViableAltException(this);
                        }
                    }
                    break;
                case 28:
                case 29:
                case 30:
                case 31:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 92;
                        this._errHandler.sync(this);
                        switch (this._input.LA(1)) {
                            case 28:
                                {
                                    this.state = 90;
                                    this.eventMarketOutcomeSpecifierId();
                                }
                                break;
                            case 29:
                            case 30:
                            case 31:
                                {
                                    this.state = 91;
                                    this.eventMarketOutcomeCompetitorId();
                                }
                                break;
                            default:
                                throw new NoViableAltException(this);
                        }
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    eventCompetitorId() {
        let localctx = new EventCompetitorIdContext(this, this._ctx, this.state);
        this.enterRule(localctx, 12, AioExpressionParser.RULE_eventCompetitorId);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 96;
                _la = this._input.LA(1);
                if (!((_la & ~0x1f) === 0 && ((1 << _la) & 14680064) !== 0)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    eventMarketSpecifierId() {
        let localctx = new EventMarketSpecifierIdContext(this, this._ctx, this.state);
        this.enterRule(localctx, 14, AioExpressionParser.RULE_eventMarketSpecifierId);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 98;
                this.match(AioExpressionParser.EM_SPECIFIER);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    eventMarketCompetitorId() {
        let localctx = new EventMarketCompetitorIdContext(this, this._ctx, this.state);
        this.enterRule(localctx, 16, AioExpressionParser.RULE_eventMarketCompetitorId);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 100;
                _la = this._input.LA(1);
                if (!((_la & ~0x1f) === 0 && ((1 << _la) & 234881024) !== 0)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    eventMarketOutcomeSpecifierId() {
        let localctx = new EventMarketOutcomeSpecifierIdContext(this, this._ctx, this.state);
        this.enterRule(localctx, 18, AioExpressionParser.RULE_eventMarketOutcomeSpecifierId);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 102;
                this.match(AioExpressionParser.EMO_SPECIFIER);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    eventMarketOutcomeCompetitorId() {
        let localctx = new EventMarketOutcomeCompetitorIdContext(this, this._ctx, this.state);
        this.enterRule(localctx, 20, AioExpressionParser.RULE_eventMarketOutcomeCompetitorId);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 104;
                _la = this._input.LA(1);
                if (!((_la & ~0x1f) === 0 && ((1 << _la) & 3758096384) !== 0)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    stringArg() {
        let localctx = new StringArgContext(this, this._ctx, this.state);
        this.enterRule(localctx, 22, AioExpressionParser.RULE_stringArg);
        try {
            localctx = new StringArgumentContext(this, localctx);
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 106;
                this.match(AioExpressionParser.STRING);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    numberArg() {
        let localctx = new NumberArgContext(this, this._ctx, this.state);
        this.enterRule(localctx, 24, AioExpressionParser.RULE_numberArg);
        try {
            localctx = new NumberArgumentContext(this, localctx);
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 108;
                this.match(AioExpressionParser.NUMBER);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    funct() {
        let localctx = new FunctContext(this, this._ctx, this.state);
        this.enterRule(localctx, 26, AioExpressionParser.RULE_funct);
        try {
            this.state = 133;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 4:
                    localctx = new FormatNumberDigitsContext(this, localctx);
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 110;
                        this.match(AioExpressionParser.FORMAT_NUMBER_DIGITS);
                        this.state = 111;
                        this.match(AioExpressionParser.PARENTHESIS_OPEN);
                        this.state = 112;
                        this.expr(0);
                        this.state = 113;
                        this.match(AioExpressionParser.COMMA);
                        this.state = 114;
                        this.expr(0);
                        this.state = 115;
                        this.match(AioExpressionParser.PARENTHESIS_CLOSE);
                    }
                    break;
                case 5:
                    localctx = new DisplayIfContext(this, localctx);
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 117;
                        this.match(AioExpressionParser.DISPLAY_IF);
                        this.state = 118;
                        this.match(AioExpressionParser.PARENTHESIS_OPEN);
                        this.state = 119;
                        this.expr(0);
                        this.state = 120;
                        this.match(AioExpressionParser.COMMA);
                        this.state = 121;
                        this.stringArg();
                        this.state = 122;
                        this.match(AioExpressionParser.PARENTHESIS_CLOSE);
                    }
                    break;
                case 6:
                    localctx = new SubstringContext(this, localctx);
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 124;
                        this.match(AioExpressionParser.SUBSTRING);
                        this.state = 125;
                        this.match(AioExpressionParser.PARENTHESIS_OPEN);
                        this.state = 126;
                        this.expr(0);
                        this.state = 127;
                        this.match(AioExpressionParser.COMMA);
                        this.state = 128;
                        this.numberArg();
                        this.state = 129;
                        this.match(AioExpressionParser.COMMA);
                        this.state = 130;
                        this.numberArg();
                        this.state = 131;
                        this.match(AioExpressionParser.PARENTHESIS_CLOSE);
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    sempred(localctx, ruleIndex, predIndex) {
        switch (ruleIndex) {
            case 4:
                return this.expr_sempred(localctx, predIndex);
        }
        return true;
    }
    expr_sempred(localctx, predIndex) {
        switch (predIndex) {
            case 0:
                return this.precpred(this._ctx, 7);
            case 1:
                return this.precpred(this._ctx, 6);
            case 2:
                return this.precpred(this._ctx, 5);
            case 3:
                return this.precpred(this._ctx, 4);
            case 4:
                return this.precpred(this._ctx, 3);
        }
        return true;
    }
    static _serializedATN = [
        4, 1, 43, 136, 2, 0, 7, 0, 2, 1, 7, 1, 2, 2, 7, 2, 2, 3, 7, 3, 2, 4, 7, 4, 2, 5, 7, 5, 2, 6, 7,
        6, 2, 7, 7, 7, 2, 8, 7, 8, 2, 9, 7, 9, 2, 10, 7, 10, 2, 11, 7, 11, 2, 12, 7, 12, 2, 13, 7, 13,
        1, 0, 5, 0, 30, 8, 0, 10, 0, 12, 0, 33, 9, 0, 1, 0, 1, 0, 1, 1, 1, 1, 3, 1, 39, 8, 1, 1, 2, 1,
        2, 5, 2, 43, 8, 2, 10, 2, 12, 2, 46, 9, 2, 1, 2, 1, 2, 1, 3, 1, 3, 3, 3, 52, 8, 3, 1, 4, 1, 4,
        1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 3, 4, 64, 8, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1,
        4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 5, 4, 81, 8, 4, 10, 4, 12, 4, 84, 9, 4,
        1, 5, 1, 5, 1, 5, 3, 5, 89, 8, 5, 1, 5, 1, 5, 3, 5, 93, 8, 5, 3, 5, 95, 8, 5, 1, 6, 1, 6, 1, 7,
        1, 7, 1, 8, 1, 8, 1, 9, 1, 9, 1, 10, 1, 10, 1, 11, 1, 11, 1, 12, 1, 12, 1, 13, 1, 13, 1, 13, 1,
        13, 1, 13, 1, 13, 1, 13, 1, 13, 1, 13, 1, 13, 1, 13, 1, 13, 1, 13, 1, 13, 1, 13, 1, 13, 1, 13,
        1, 13, 1, 13, 1, 13, 1, 13, 1, 13, 1, 13, 3, 13, 134, 8, 13, 1, 13, 0, 1, 8, 14, 0, 2, 4, 6, 8,
        10, 12, 14, 16, 18, 20, 22, 24, 26, 0, 7, 1, 0, 9, 10, 1, 0, 7, 8, 2, 0, 12, 15, 19, 20, 1, 0,
        16, 17, 1, 0, 21, 23, 1, 0, 25, 27, 1, 0, 29, 31, 140, 0, 31, 1, 0, 0, 0, 2, 38, 1, 0, 0, 0, 4,
        40, 1, 0, 0, 0, 6, 49, 1, 0, 0, 0, 8, 63, 1, 0, 0, 0, 10, 94, 1, 0, 0, 0, 12, 96, 1, 0, 0, 0,
        14, 98, 1, 0, 0, 0, 16, 100, 1, 0, 0, 0, 18, 102, 1, 0, 0, 0, 20, 104, 1, 0, 0, 0, 22, 106, 1,
        0, 0, 0, 24, 108, 1, 0, 0, 0, 26, 133, 1, 0, 0, 0, 28, 30, 3, 2, 1, 0, 29, 28, 1, 0, 0, 0, 30,
        33, 1, 0, 0, 0, 31, 29, 1, 0, 0, 0, 31, 32, 1, 0, 0, 0, 32, 34, 1, 0, 0, 0, 33, 31, 1, 0, 0, 0,
        34, 35, 5, 0, 0, 1, 35, 1, 1, 0, 0, 0, 36, 39, 3, 4, 2, 0, 37, 39, 5, 2, 0, 0, 38, 36, 1, 0, 0,
        0, 38, 37, 1, 0, 0, 0, 39, 3, 1, 0, 0, 0, 40, 44, 5, 1, 0, 0, 41, 43, 3, 6, 3, 0, 42, 41, 1, 0,
        0, 0, 43, 46, 1, 0, 0, 0, 44, 42, 1, 0, 0, 0, 44, 45, 1, 0, 0, 0, 45, 47, 1, 0, 0, 0, 46, 44, 1,
        0, 0, 0, 47, 48, 5, 3, 0, 0, 48, 5, 1, 0, 0, 0, 49, 51, 3, 8, 4, 0, 50, 52, 5, 36, 0, 0, 51, 50,
        1, 0, 0, 0, 51, 52, 1, 0, 0, 0, 52, 7, 1, 0, 0, 0, 53, 54, 6, 4, -1, 0, 54, 64, 5, 32, 0, 0, 55,
        64, 3, 10, 5, 0, 56, 57, 5, 41, 0, 0, 57, 58, 3, 8, 4, 0, 58, 59, 5, 42, 0, 0, 59, 64, 1, 0, 0,
        0, 60, 61, 5, 18, 0, 0, 61, 64, 3, 8, 4, 2, 62, 64, 3, 26, 13, 0, 63, 53, 1, 0, 0, 0, 63, 55, 1,
        0, 0, 0, 63, 56, 1, 0, 0, 0, 63, 60, 1, 0, 0, 0, 63, 62, 1, 0, 0, 0, 64, 82, 1, 0, 0, 0, 65, 66,
        10, 7, 0, 0, 66, 67, 7, 0, 0, 0, 67, 81, 3, 8, 4, 8, 68, 69, 10, 6, 0, 0, 69, 70, 7, 1, 0, 0,
        70, 81, 3, 8, 4, 7, 71, 72, 10, 5, 0, 0, 72, 73, 5, 11, 0, 0, 73, 81, 3, 8, 4, 6, 74, 75, 10, 4,
        0, 0, 75, 76, 7, 2, 0, 0, 76, 81, 3, 8, 4, 5, 77, 78, 10, 3, 0, 0, 78, 79, 7, 3, 0, 0, 79, 81,
        3, 8, 4, 4, 80, 65, 1, 0, 0, 0, 80, 68, 1, 0, 0, 0, 80, 71, 1, 0, 0, 0, 80, 74, 1, 0, 0, 0, 80,
        77, 1, 0, 0, 0, 81, 84, 1, 0, 0, 0, 82, 80, 1, 0, 0, 0, 82, 83, 1, 0, 0, 0, 83, 9, 1, 0, 0, 0,
        84, 82, 1, 0, 0, 0, 85, 95, 3, 12, 6, 0, 86, 89, 3, 14, 7, 0, 87, 89, 3, 16, 8, 0, 88, 86, 1, 0,
        0, 0, 88, 87, 1, 0, 0, 0, 89, 95, 1, 0, 0, 0, 90, 93, 3, 18, 9, 0, 91, 93, 3, 20, 10, 0, 92, 90,
        1, 0, 0, 0, 92, 91, 1, 0, 0, 0, 93, 95, 1, 0, 0, 0, 94, 85, 1, 0, 0, 0, 94, 88, 1, 0, 0, 0, 94,
        92, 1, 0, 0, 0, 95, 11, 1, 0, 0, 0, 96, 97, 7, 4, 0, 0, 97, 13, 1, 0, 0, 0, 98, 99, 5, 24, 0, 0,
        99, 15, 1, 0, 0, 0, 100, 101, 7, 5, 0, 0, 101, 17, 1, 0, 0, 0, 102, 103, 5, 28, 0, 0, 103, 19,
        1, 0, 0, 0, 104, 105, 7, 6, 0, 0, 105, 21, 1, 0, 0, 0, 106, 107, 5, 43, 0, 0, 107, 23, 1, 0, 0,
        0, 108, 109, 5, 32, 0, 0, 109, 25, 1, 0, 0, 0, 110, 111, 5, 4, 0, 0, 111, 112, 5, 41, 0, 0, 112,
        113, 3, 8, 4, 0, 113, 114, 5, 34, 0, 0, 114, 115, 3, 8, 4, 0, 115, 116, 5, 42, 0, 0, 116, 134,
        1, 0, 0, 0, 117, 118, 5, 5, 0, 0, 118, 119, 5, 41, 0, 0, 119, 120, 3, 8, 4, 0, 120, 121, 5, 34,
        0, 0, 121, 122, 3, 22, 11, 0, 122, 123, 5, 42, 0, 0, 123, 134, 1, 0, 0, 0, 124, 125, 5, 6, 0, 0,
        125, 126, 5, 41, 0, 0, 126, 127, 3, 8, 4, 0, 127, 128, 5, 34, 0, 0, 128, 129, 3, 24, 12, 0, 129,
        130, 5, 34, 0, 0, 130, 131, 3, 24, 12, 0, 131, 132, 5, 42, 0, 0, 132, 134, 1, 0, 0, 0, 133, 110,
        1, 0, 0, 0, 133, 117, 1, 0, 0, 0, 133, 124, 1, 0, 0, 0, 134, 27, 1, 0, 0, 0, 11, 31, 38, 44, 51,
        63, 80, 82, 88, 92, 94, 133,
    ];
    static __ATN;
    static get _ATN() {
        if (!AioExpressionParser.__ATN) {
            AioExpressionParser.__ATN = new ATNDeserializer().deserialize(AioExpressionParser._serializedATN);
        }
        return AioExpressionParser.__ATN;
    }
    static DecisionsToDFA = AioExpressionParser._ATN.decisionToState.map((ds, index) => new DFA(ds, index));
}
export class InputContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    EOF() {
        return this.getToken(AioExpressionParser.EOF, 0);
    }
    element_list() {
        return this.getTypedRuleContexts(ElementContext);
    }
    element(i) {
        return this.getTypedRuleContext(ElementContext, i);
    }
    get ruleIndex() {
        return AioExpressionParser.RULE_input;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitInput) {
            return visitor.visitInput(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ElementContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    dynamicExpr() {
        return this.getTypedRuleContext(DynamicExprContext, 0);
    }
    TEXT() {
        return this.getToken(AioExpressionParser.TEXT, 0);
    }
    get ruleIndex() {
        return AioExpressionParser.RULE_element;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitElement) {
            return visitor.visitElement(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DynamicExprContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    DYNAMIC_START() {
        return this.getToken(AioExpressionParser.DYNAMIC_START, 0);
    }
    DYNAMIC_END() {
        return this.getToken(AioExpressionParser.DYNAMIC_END, 0);
    }
    statement_list() {
        return this.getTypedRuleContexts(StatementContext);
    }
    statement(i) {
        return this.getTypedRuleContext(StatementContext, i);
    }
    get ruleIndex() {
        return AioExpressionParser.RULE_dynamicExpr;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDynamicExpr) {
            return visitor.visitDynamicExpr(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class StatementContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    expr() {
        return this.getTypedRuleContext(ExprContext, 0);
    }
    SEMICOLON() {
        return this.getToken(AioExpressionParser.SEMICOLON, 0);
    }
    get ruleIndex() {
        return AioExpressionParser.RULE_statement;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitStatement) {
            return visitor.visitStatement(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ExprContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    get ruleIndex() {
        return AioExpressionParser.RULE_expr;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
export class NumberContext extends ExprContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    NUMBER() {
        return this.getToken(AioExpressionParser.NUMBER, 0);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNumber) {
            return visitor.visitNumber(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ExtractIdContext extends ExprContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    id() {
        return this.getTypedRuleContext(IdContext, 0);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExtractId) {
            return visitor.visitExtractId(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ParensContext extends ExprContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    PARENTHESIS_OPEN() {
        return this.getToken(AioExpressionParser.PARENTHESIS_OPEN, 0);
    }
    expr() {
        return this.getTypedRuleContext(ExprContext, 0);
    }
    PARENTHESIS_CLOSE() {
        return this.getToken(AioExpressionParser.PARENTHESIS_CLOSE, 0);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitParens) {
            return visitor.visitParens(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NotContext extends ExprContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    NOT() {
        return this.getToken(AioExpressionParser.NOT, 0);
    }
    expr() {
        return this.getTypedRuleContext(ExprContext, 0);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNot) {
            return visitor.visitNot(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class FuncContext extends ExprContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    funct() {
        return this.getTypedRuleContext(FunctContext, 0);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitFunc) {
            return visitor.visitFunc(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AddSubContext extends ExprContext {
    _op;
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    expr_list() {
        return this.getTypedRuleContexts(ExprContext);
    }
    expr(i) {
        return this.getTypedRuleContext(ExprContext, i);
    }
    ADD() {
        return this.getToken(AioExpressionParser.ADD, 0);
    }
    SUB() {
        return this.getToken(AioExpressionParser.SUB, 0);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAddSub) {
            return visitor.visitAddSub(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class RelationalContext extends ExprContext {
    _op;
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    expr_list() {
        return this.getTypedRuleContexts(ExprContext);
    }
    expr(i) {
        return this.getTypedRuleContext(ExprContext, i);
    }
    LT() {
        return this.getToken(AioExpressionParser.LT, 0);
    }
    LTE() {
        return this.getToken(AioExpressionParser.LTE, 0);
    }
    GT() {
        return this.getToken(AioExpressionParser.GT, 0);
    }
    GTE() {
        return this.getToken(AioExpressionParser.GTE, 0);
    }
    EQUALS() {
        return this.getToken(AioExpressionParser.EQUALS, 0);
    }
    NOT_EQUALS() {
        return this.getToken(AioExpressionParser.NOT_EQUALS, 0);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitRelational) {
            return visitor.visitRelational(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ModuloContext extends ExprContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    expr_list() {
        return this.getTypedRuleContexts(ExprContext);
    }
    expr(i) {
        return this.getTypedRuleContext(ExprContext, i);
    }
    MOD() {
        return this.getToken(AioExpressionParser.MOD, 0);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitModulo) {
            return visitor.visitModulo(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class MulDivContext extends ExprContext {
    _op;
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    expr_list() {
        return this.getTypedRuleContexts(ExprContext);
    }
    expr(i) {
        return this.getTypedRuleContext(ExprContext, i);
    }
    MUL() {
        return this.getToken(AioExpressionParser.MUL, 0);
    }
    DIV() {
        return this.getToken(AioExpressionParser.DIV, 0);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitMulDiv) {
            return visitor.visitMulDiv(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LogicalContext extends ExprContext {
    _op;
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    expr_list() {
        return this.getTypedRuleContexts(ExprContext);
    }
    expr(i) {
        return this.getTypedRuleContext(ExprContext, i);
    }
    OR() {
        return this.getToken(AioExpressionParser.OR, 0);
    }
    AND() {
        return this.getToken(AioExpressionParser.AND, 0);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitLogical) {
            return visitor.visitLogical(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class IdContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    eventCompetitorId() {
        return this.getTypedRuleContext(EventCompetitorIdContext, 0);
    }
    eventMarketSpecifierId() {
        return this.getTypedRuleContext(EventMarketSpecifierIdContext, 0);
    }
    eventMarketCompetitorId() {
        return this.getTypedRuleContext(EventMarketCompetitorIdContext, 0);
    }
    eventMarketOutcomeSpecifierId() {
        return this.getTypedRuleContext(EventMarketOutcomeSpecifierIdContext, 0);
    }
    eventMarketOutcomeCompetitorId() {
        return this.getTypedRuleContext(EventMarketOutcomeCompetitorIdContext, 0);
    }
    get ruleIndex() {
        return AioExpressionParser.RULE_id;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitId) {
            return visitor.visitId(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class EventCompetitorIdContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    E_C_NAME() {
        return this.getToken(AioExpressionParser.E_C_NAME, 0);
    }
    E_C_T_NAME() {
        return this.getToken(AioExpressionParser.E_C_T_NAME, 0);
    }
    E_C_P_NAME() {
        return this.getToken(AioExpressionParser.E_C_P_NAME, 0);
    }
    get ruleIndex() {
        return AioExpressionParser.RULE_eventCompetitorId;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitEventCompetitorId) {
            return visitor.visitEventCompetitorId(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class EventMarketSpecifierIdContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    EM_SPECIFIER() {
        return this.getToken(AioExpressionParser.EM_SPECIFIER, 0);
    }
    get ruleIndex() {
        return AioExpressionParser.RULE_eventMarketSpecifierId;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitEventMarketSpecifierId) {
            return visitor.visitEventMarketSpecifierId(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class EventMarketCompetitorIdContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    EM_C_NAME() {
        return this.getToken(AioExpressionParser.EM_C_NAME, 0);
    }
    EM_C_T_NAME() {
        return this.getToken(AioExpressionParser.EM_C_T_NAME, 0);
    }
    EM_C_P_NAME() {
        return this.getToken(AioExpressionParser.EM_C_P_NAME, 0);
    }
    get ruleIndex() {
        return AioExpressionParser.RULE_eventMarketCompetitorId;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitEventMarketCompetitorId) {
            return visitor.visitEventMarketCompetitorId(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class EventMarketOutcomeSpecifierIdContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    EMO_SPECIFIER() {
        return this.getToken(AioExpressionParser.EMO_SPECIFIER, 0);
    }
    get ruleIndex() {
        return AioExpressionParser.RULE_eventMarketOutcomeSpecifierId;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitEventMarketOutcomeSpecifierId) {
            return visitor.visitEventMarketOutcomeSpecifierId(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class EventMarketOutcomeCompetitorIdContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    EMO_C_NAME() {
        return this.getToken(AioExpressionParser.EMO_C_NAME, 0);
    }
    EMO_C_T_NAME() {
        return this.getToken(AioExpressionParser.EMO_C_T_NAME, 0);
    }
    EMO_C_P_NAME() {
        return this.getToken(AioExpressionParser.EMO_C_P_NAME, 0);
    }
    get ruleIndex() {
        return AioExpressionParser.RULE_eventMarketOutcomeCompetitorId;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitEventMarketOutcomeCompetitorId) {
            return visitor.visitEventMarketOutcomeCompetitorId(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class StringArgContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    get ruleIndex() {
        return AioExpressionParser.RULE_stringArg;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
export class StringArgumentContext extends StringArgContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    STRING() {
        return this.getToken(AioExpressionParser.STRING, 0);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitStringArgument) {
            return visitor.visitStringArgument(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NumberArgContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    get ruleIndex() {
        return AioExpressionParser.RULE_numberArg;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
export class NumberArgumentContext extends NumberArgContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    NUMBER() {
        return this.getToken(AioExpressionParser.NUMBER, 0);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNumberArgument) {
            return visitor.visitNumberArgument(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class FunctContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    get ruleIndex() {
        return AioExpressionParser.RULE_funct;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
export class FormatNumberDigitsContext extends FunctContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    FORMAT_NUMBER_DIGITS() {
        return this.getToken(AioExpressionParser.FORMAT_NUMBER_DIGITS, 0);
    }
    PARENTHESIS_OPEN() {
        return this.getToken(AioExpressionParser.PARENTHESIS_OPEN, 0);
    }
    expr_list() {
        return this.getTypedRuleContexts(ExprContext);
    }
    expr(i) {
        return this.getTypedRuleContext(ExprContext, i);
    }
    COMMA() {
        return this.getToken(AioExpressionParser.COMMA, 0);
    }
    PARENTHESIS_CLOSE() {
        return this.getToken(AioExpressionParser.PARENTHESIS_CLOSE, 0);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitFormatNumberDigits) {
            return visitor.visitFormatNumberDigits(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class DisplayIfContext extends FunctContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    DISPLAY_IF() {
        return this.getToken(AioExpressionParser.DISPLAY_IF, 0);
    }
    PARENTHESIS_OPEN() {
        return this.getToken(AioExpressionParser.PARENTHESIS_OPEN, 0);
    }
    expr() {
        return this.getTypedRuleContext(ExprContext, 0);
    }
    COMMA() {
        return this.getToken(AioExpressionParser.COMMA, 0);
    }
    stringArg() {
        return this.getTypedRuleContext(StringArgContext, 0);
    }
    PARENTHESIS_CLOSE() {
        return this.getToken(AioExpressionParser.PARENTHESIS_CLOSE, 0);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDisplayIf) {
            return visitor.visitDisplayIf(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class SubstringContext extends FunctContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    SUBSTRING() {
        return this.getToken(AioExpressionParser.SUBSTRING, 0);
    }
    PARENTHESIS_OPEN() {
        return this.getToken(AioExpressionParser.PARENTHESIS_OPEN, 0);
    }
    expr() {
        return this.getTypedRuleContext(ExprContext, 0);
    }
    COMMA_list() {
        return this.getTokens(AioExpressionParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(AioExpressionParser.COMMA, i);
    }
    numberArg_list() {
        return this.getTypedRuleContexts(NumberArgContext);
    }
    numberArg(i) {
        return this.getTypedRuleContext(NumberArgContext, i);
    }
    PARENTHESIS_CLOSE() {
        return this.getToken(AioExpressionParser.PARENTHESIS_CLOSE, 0);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitSubstring) {
            return visitor.visitSubstring(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
